import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import Decimal from 'decimal.js-light';

export function diffInDays(first: Date, last: Date) {
  const dateFirst = new Date(first.toISOString().split('T')[0]);
  const dateLast = new Date(last.toISOString().split('T')[0]);

  dateLast.setDate(dateLast.getDate() + 1);

  return Math.round(
    (dateLast.getTime() - dateFirst.getTime()) / (1000 * 3600 * 24),
  );
}

export function diffInMonths(first: Date, last: Date) {
  let months = (last.getFullYear() - first.getFullYear()) * 12;
  months -= first.getMonth();
  months += last.getMonth() + 1;

  return months <= 0 ? 0 : months;
}

export function formatDate(date: string | unknown, periodType: string) {
  if (typeof date !== 'string') return null;

  const djs = dayjs(date).locale('ru');

  switch (periodType) {
    case 'day':
      return djs.format('DD.MM.YYYY');
    case 'month':
      return djs.format('YYYY MMM');
    default:
      return djs.format(periodType);
  }
}

export function generateDates<T = object>(
  minDate: string | Date,
  maxDate: string | Date,
  addDays: number = 0,
) {
  const dates: {
    [date: string]: { i: number; records: T[]; stake: Decimal; gain: Decimal };
  } = {};
  const start = new Date(minDate);
  const end = new Date(maxDate);

  // FIXME summer time shift removed exact date
  start.setHours(12); // just because of daylight shift

  const dayMs = 1000 * 60 * 60 * 24;
  const diffMs = end.getTime() - start.getTime();
  const count = Math.floor(diffMs / dayMs) + 1 + addDays;

  for (let i = 0, d = new Date(start); i <= count; i++) {
    const iso = d.toISOString().split('T')[0]; // формат YYYY-MM-DD

    dates[iso] = {
      i,
      records: [] as T[],
      stake: new Decimal(0),
      gain: new Decimal(0),
    };

    d.setDate(d.getDate() + 1);
  }

  return dates;
}

export function toLocalISO(date: Date) {
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60 * 1000);
}

export function fromLocalISO(date: Date) {
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() + offset * 60 * 1000);
}
